"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = AnnotationCalloutCircle;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SubjectCircle = require("../Subject/SubjectCircle");

var _SubjectCircle2 = _interopRequireDefault(_SubjectCircle);

var _ConnectorElbow = require("../Connector/ConnectorElbow");

var _ConnectorElbow2 = _interopRequireDefault(_ConnectorElbow);

var _classnames = require("../classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _Type = require("./Type");

var _Type2 = _interopRequireDefault(_Type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AnnotationCalloutCircle(props) {
  var className = (0, _classnames2.default)("callout circle", props.className);
  return (0, _Type2.default)(_extends({}, props, { className: className }), _ConnectorElbow2.default, { lineType: "horizontal" }, _SubjectCircle2.default, { radius: 20 });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-annotation/lib/Types/AnnotationCalloutCircle.js
// module id = 101
// module chunks = 0